import { Integration } from '../types'
import { INTEGRATIONS } from '../data/integrations'
import { delay } from './store'

export function listIntegrations(): Integration[] {
  return INTEGRATIONS
}

/**
 * TODO(Supabase / OAuth): aquí se lanzará el flujo real de conexión de cada
 * integración. Por ahora no se simula ninguna conexión activa.
 */
export async function requestConnection(integrationId: string): Promise<string> {
  await delay(null, 300)
  return integrationId
}
